module.exports = __webpack_public_path__ + "static/media/tree_26.74bddaa4.jpeg";